"use strict";

const game_version = "v0.5.5.30";

function get_game_version() {
    return game_version;
}

export { game_version, get_game_version }